// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"a817f2a8","419":"130f8fe8","563":"79af0744","942":"81745c11"}[chunkId] + ".chunk.js";
};